import React, { Fragment, Component } from 'react';
import LoadMoreButton from './LoadMoreButton';
import { scrollWindowTo, computeDistanceFromTop } from '../../../lib/utils';

const limit = 4;
const minLength = limit - 1;
const firstPage = 1;

export default class LoadMore extends Component {
  state = {
    cardsToView: minLength,
    pageNo: firstPage,
  };

  getSnapshotBeforeUpdate(prevProps) {
    const addedCards = this.props.children.length;
    const pageNo = Math.ceil((addedCards + 1) / limit);
    // const cardsToView = pageNo * limit - 1;
    // if (prevProps.isDraft !== this.props.isDraft) {
    //   //expands row when is draft
    //   if (this.props.isDraft) {
    //     return { cardsToView, pageNo }
    //   }
    //   //collapses row when is not draft
    //   else if (!this.props.isDraft) { return { cardsToView: minLength, pageNo: firstPage } }
    // }

    //expands row when new card is added
    if (this.props.isDraft) {
      if (prevProps.children.length !== addedCards) {
        return { cardsToView: addedCards, pageNo };
      }
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    //scroll into view when load more or see less
    if (prevState.cardsToView !== this.state.cardsToView) {
      const elmY = computeDistanceFromTop(this.props.elmId) + 50;
      scrollWindowTo(elmY - window.innerHeight, 400);
    }

    if (snapshot) {
      setTimeout(
        () =>
          this.setState({
            cardsToView: snapshot.cardsToView,
            pageNo: snapshot.pageNo,
          }),
        500
      );
    }
  }

  render() {
    const { children, lastComponent, elmId } = this.props;
    const cardsToView = this.state.cardsToView;
    return (
      <Fragment>
        {children.slice(0, cardsToView)}
        {lastComponent}
        <div className="col-12 load-more-wrap text-center" id={elmId}>
          {this.renderLoadMore()}
          {this.renderSeeLess()}
        </div>
      </Fragment>
    );
  }

  renderLoadMore = () => {
    const maxLength = this.props.children.length;
    let canLoadMore = true;

    if (maxLength <= this.state.cardsToView) canLoadMore = false;
    if (canLoadMore) return <LoadMoreButton type={'loadMore'} edit={this.loadMore} />;
  };

  renderSeeLess = () => {
    let canSeeLess = false;

    if (this.state.cardsToView > minLength) canSeeLess = true;
    if (canSeeLess) return <LoadMoreButton type={'seeLess'} edit={this.seeLess} />;
  };

  loadMore = () => {
    const newPage = this.state.pageNo + 1;
    const cardsToView = newPage * limit - 1;
    this.setState({
      pageNo: newPage,
      cardsToView: cardsToView,
    });
  };

  seeLess = () => {
    const newPage = this.state.pageNo - 1;
    const cardsToView = newPage * limit - 1;
    this.setState({
      pageNo: newPage,
      cardsToView: cardsToView,
    });
  };
}



// WEBPACK FOOTER //
// ./src/screens/Trek/DayTrail/LoadMore.js